import { useEffect } from 'react';

const ORDER_ENDPOINT_REGEX = /\/(api\/order|order)/;
const METADATA_KEY = '__CHECKOUT_METADATA__';
const INTERCEPTOR_FLAG = '__ORDER_METADATA_INTERCEPTOR_INSTALLED__';

const getGlobalMetadata = () => {
  const metadata = (window as any)[METADATA_KEY];
  return Array.isArray(metadata) && metadata.length > 0 ? metadata : null;
};

const tryInjectMetadata = (body?: string) => {
  if (!body || typeof body !== 'string') return null;

  try {
    const parsed = JSON.parse(body);
    if (parsed?.metadata) return null;

    const metadata = getGlobalMetadata();
    if (!metadata) return null;

    return JSON.stringify({
      ...parsed,
      metadata,
    });
  } catch {
    return null;
  }
};

export function useOrderMetadataInterceptor() {
  useEffect(() => {
    if (typeof window === 'undefined') return;

    // 🔒 Evitar instalación múltiple global
    if ((window as any)[INTERCEPTOR_FLAG]) return;
    (window as any)[INTERCEPTOR_FLAG] = true;

    /* ================= FETCH ================= */
    const originalFetch = window.fetch;

    window.fetch = function (input: RequestInfo | URL, init?: RequestInit) {
      if (typeof input === 'string' && ORDER_ENDPOINT_REGEX.test(input) && init?.body) {
        const modifiedBody = tryInjectMetadata(init.body as string);

        if (modifiedBody) {
          return originalFetch(input, {
            ...init,
            body: modifiedBody,
          });
        }
      }

      return originalFetch(input, init);
    };

    /* ================= XHR ================= */
    const originalXHROpen = XMLHttpRequest.prototype.open;
    const originalXHRSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (
      method: string,
      url: string | URL,
      async: boolean = true,
      username?: string | null,
      password?: string | null,
    ) {
      (this as any)._url = url;
      return originalXHROpen.call(this, method, url, async, username, password);
    };

    XMLHttpRequest.prototype.send = function (body?: any) {
      const url = (this as any)._url;

      if (typeof url === 'string' && ORDER_ENDPOINT_REGEX.test(url)) {
        const modifiedBody = tryInjectMetadata(body);
        if (modifiedBody) {
          return originalXHRSend.call(this, modifiedBody);
        }
      }

      return originalXHRSend.call(this, body);
    };
  }, []);
}
